import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// --- Session persistence: auto-refresh the access token once on 401, then retry ---
let refreshPromise = null;
const AUTH_PATHS = ["/auth/login", "/auth/refresh", "/auth/register", "/auth/logout"];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    const isAuthCall = AUTH_PATHS.some((p) => url.includes(p));
    if (status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        }
        await refreshPromise;
        return api(original);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Meaningful auth error messages instead of a generic fallback.
export function authErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (detail) return formatApiErrorDetail(detail);
  if (err?.response) {
    const s = err.response.status;
    if (s === 401) return "Invalid email or password.";
    if (s === 403) return "You don't have permission to access this account.";
    if (s === 429) return "Too many attempts. Please wait a few minutes and try again.";
    if (s >= 500) return "Server error. Please try again in a moment.";
    return "Unable to sign in. Please try again.";
  }
  if (err?.request) return "Cannot reach the server. Check your connection and try again.";
  return "An unexpected error occurred. Please try again.";
}

export const money = (n) =>
  "₡" + Number(n || 0).toLocaleString("es-CR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
